export default __webpack_public_path__ + "static/media/chevronRight.9fe0c390.svg";